import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

const PORTAIL_ROLES = ["joueur", "parent"];

export default function ProtectedRoute({ children, allowPortail = false }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-slate-400 text-sm">Chargement...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  // joueur/parent only have access to /portail and their own player report
  if (PORTAIL_ROLES.includes(user.role) && !allowPortail) {
    return <Navigate to="/portail" replace />;
  }
  return children;
}
